import React, { useState } from 'react';
import './log_in_mobile.css';


export function CreateAccountMobileStep2({ formData, handleChange, errors, onNext }) {
  const [showPass, setShowPass] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  return (
    <div className="mobile-auth-container" dir="rtl">
      <div className="mobile-auth-card">
        <h4 className="mobile-card-title">إعداد كلمة المرور</h4>
        <form onSubmit={onNext}>
          
          <div className={`mobile-input-group ${errors?.password ? 'input-error' : ''}`}>
            <input type={showPass ? 'text' : 'password'} name="password" placeholder="كلمة المرور" value={formData.password || ''} onChange={handleChange} required />
            <i className="fa-solid fa-lock mobile-input-icon"></i>
            <i className={`fa-solid ${showPass ? 'fa-eye-slash' : 'fa-eye'} mobile-toggle-password`} onClick={() => setShowPass(!showPass)}></i>
          </div>
          {errors?.password && <span className="mobile-error-text">{errors.password}</span>}

          <div className={`mobile-input-group ${errors?.confirmPassword ? 'input-error' : ''}`}>
            <input type={showConfirm ? 'text' : 'password'} name="confirmPassword" placeholder="تأكيد كلمة المرور" value={formData.confirmPassword || ''} onChange={handleChange} required />
            <i className="fa-solid fa-lock mobile-input-icon"></i>
            <i className={`fa-solid ${showConfirm ? 'fa-eye-slash' : 'fa-eye'} mobile-toggle-password`} onClick={() => setShowConfirm(!showConfirm)}></i>
          </div>
          {errors?.confirmPassword && <span className="mobile-error-text">{errors.confirmPassword}</span>}

          <button type="submit" className="mobile-btn-submit">متابعة</button>
        </form>
      </div>
    </div>
  );
}
// مقتطف لخطوة المشفى والمدينة (Doctor Log In-3.png)
export function CreateAccountMobileStep3({ formData, setFormData, onSubmit, cities, hospitals, specialties, onCityChange, errors, apiError, loading }) {
  return (
    <div className="mobile-auth-container" dir="rtl">
      <div className="mobile-auth-card">
        <h4 className="mobile-card-title">المعلومات المهنية</h4>
        <form onSubmit={(e) => { e.preventDefault(); onSubmit(); }}>
          
          {apiError && <div style={{textAlign: "center", marginBottom: "15px", color: "red", fontWeight: "bold", fontSize: "14px"}}>{apiError}</div>}

          <div className={`mobile-input-group ${errors?.specialty ? 'input-error' : ''}`}>
            <select name="specialty" value={formData.specialty || ''} onChange={(e) => setFormData({...formData, specialty: e.target.value})} required disabled={loading}>
              <option value="">الاختصاص</option>
              {specialties && specialties.map((s, i) => (
                <option key={i} value={s}>{s}</option>
              ))}
            </select>
            <i className="fa-solid fa-stethoscope mobile-input-icon"></i>
          </div>
          {errors?.specialty && <span className="mobile-error-text">{errors.specialty}</span>}

          <div className={`mobile-input-group ${errors?.city ? 'input-error' : ''}`}>
            <select name="city" value={formData.city || ''} onChange={onCityChange} required disabled={loading}>
              <option value="">المحافظة</option>
              {cities && cities.map((city, i) => (
                <option key={i} value={city}>{city}</option>
              ))}
            </select>
            <i className="fa-solid fa-city mobile-input-icon"></i>
          </div>
          {errors?.city && <span className="mobile-error-text">{errors.city}</span>}

          <div className={`mobile-input-group ${errors?.hospital_id ? 'input-error' : ''}`}>
            <select name="hospital_id" value={formData.hospital_id || ''} onChange={(e) => setFormData({...formData, hospital_id: e.target.value})} required disabled={loading}>
              <option value="">المشفى (المركز)</option>
              {hospitals && hospitals.map((h) => (
                <option key={h.id} value={h.id}>{h.name}</option>
              ))}
            </select>
            <i className="fa-solid fa-hospital mobile-input-icon"></i>
          </div>
          {errors?.hospital_id && <span className="mobile-error-text">{errors.hospital_id}</span>}

          <div className="mobile-input-group">
            <input type="text" name="address" placeholder="عنوان العيادة (اختياري)" value={formData.address || ''} onChange={(e) => setFormData({...formData, address: e.target.value})} disabled={loading} />
            <i className="fa-solid fa-location-dot mobile-input-icon"></i>
          </div>

          <button type="submit" className="mobile-btn-submit" disabled={loading}>
            {loading ? "جاري الإنشاء..." : "إنشاء حساب"}
          </button>
        </form>
      </div>
    </div>
  );
}